import React, { useState } from "react";
import { Menu, MenuItem, useTheme } from "@mui/material";
import { FiDownload } from "react-icons/fi";
import { BtnIcon } from "./SharedPageStyles";
import { exportToCSV, exportToJSON } from "../utils/exportUtils";
import { tokens } from "../utils/theme";

export const ExportButton = ({
  data,
  filename = "export",
  title = "Download data",
  primary = false,
  disabled = false
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const colors = tokens(theme.palette.mode);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExportCSV = () => {
    exportToCSV(data, filename);
    handleClose();
  };

  const handleExportJSON = () => {
    exportToJSON(data, filename);
    handleClose();
  };

  return (
    <>
      <BtnIcon
        primary={primary}
        aria-label="Download data"
        onClick={handleClick}
        title={title}
        disabled={disabled}
      >
        <FiDownload />
      </BtnIcon>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        PaperProps={{
          sx: {
            background: isDark
              ? "linear-gradient(160deg, #161a29 0%, #0f121d 100%)"
              : "linear-gradient(160deg, #ffffff 0%, #f8fafc 100%)",
            color: isDark ? colors.grey[100] : colors.grey[200],
            borderRadius: "10px",
            border: `1px solid ${colors.grey[500]}`,
            boxShadow: isDark
              ? "0 14px 34px rgba(0, 0, 0, 0.75), 0 0 16px rgba(130, 170, 255, 0.12)"
              : "0 10px 24px rgba(0, 0, 0, 0.10)",
            backdropFilter: "blur(12px)",
            minWidth: "86px",
            padding: "5px",
            mt: "5px"
          }
        }}
        MenuListProps={{
          sx: {
            padding: 0,
            display: "flex",
            flexDirection: "column",
            gap: "4px"
          }
        }}
      >
        <MenuItem
          onClick={handleExportJSON}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4px 6px",
            borderRadius: "6px",
            minHeight: "unset",
            "&:hover": {
              bgcolor: isDark ? "rgba(128, 203, 196, 0.12)" : "rgba(15, 118, 110, 0.08)"
            }
          }}
        >
          <span
            style={{
              fontSize: "11px",
              fontWeight: 800,
              padding: "4px 12px",
              borderRadius: "6px",
              background: isDark ? "rgba(128, 203, 196, 0.14)" : "rgba(15, 118, 110, 0.08)",
              color: isDark ? "#80cbc4" : "#0f766e",
              border: isDark ? "1px solid rgba(128, 203, 196, 0.38)" : "1px solid rgba(15, 118, 110, 0.28)",
              fontFamily: "'JetBrains Mono', Consolas, monospace",
              letterSpacing: "0.5px",
              display: "inline-block",
              textAlign: "center",
              width: "100%",
              transition: "all 0.18s ease"
            }}
          >
            JSON
          </span>
        </MenuItem>

        <MenuItem
          onClick={handleExportCSV}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4px 6px",
            borderRadius: "6px",
            minHeight: "unset",
            "&:hover": {
              bgcolor: isDark ? "rgba(130, 170, 255, 0.12)" : "rgba(37, 99, 235, 0.08)"
            }
          }}
        >
          <span
            style={{
              fontSize: "11px",
              fontWeight: 800,
              padding: "4px 12px",
              borderRadius: "6px",
              background: isDark ? "rgba(130, 170, 255, 0.14)" : "rgba(37, 99, 235, 0.08)",
              color: isDark ? "#82aaff" : "#1d4ed8",
              border: isDark ? "1px solid rgba(130, 170, 255, 0.38)" : "1px solid rgba(37, 99, 235, 0.28)",
              fontFamily: "'JetBrains Mono', Consolas, monospace",
              letterSpacing: "0.5px",
              display: "inline-block",
              textAlign: "center",
              width: "100%",
              transition: "all 0.18s ease"
            }}
          >
            CSV
          </span>
        </MenuItem>
      </Menu>
    </>
  );
};

export default ExportButton;
